/**
* @GpsTagAddDialog.vue
* @Description gps标签分配组件
* @Author CC
* @Date 2025/09/20
*/

/* HTML */
<template>
    <div v-if="dialogTreeItem.dialogFormVisible">
        <el-dialog :title="dialogTreeItem.title"
                   :visible.sync="dialogTreeItem.dialogFormVisible"
                   :close-on-click-modal="false"
                   custom-class="form-dialog"
                   v-dialogDrag
                   class="dialog_title"
                   @close="handleDialogClose"
        >
            <el-form :inline="true" :model="searchForm" ref="searchForm" style="margin-bottom: 10px;">
                <el-form-item>
                    <span >筛选条件：</span>
                </el-form-item>
                <el-form-item prop="keyword">
                    <el-input v-model="searchForm.keyword" placeholder="请输入标签编号/序号" clearable :style="{width: '300px'}">
                        <i slot="suffix" class="el-input__icon el-icon-search" @click="search"></i>
                    </el-input>
                </el-form-item>
                <el-form-item style="float: right;">
                    <el-button type="primary" class="el-icon-delete" size="mini" @click="completelyDelete">批量删除</el-button>
                </el-form-item>
            </el-form>

            <!-- 表格 -->
            <DynamicTable ref="dynamicTable"
                          :previewTitle="previewTitle"
                          :previewData="searchResult"
                          :selectBox="true"
                          :optionButton="false"
                          @selectRow="selectRow"
                          @selectRows="selectRows"
                          :key="dynamicTableKey"
                          :showSerialNumber="showSerialNumber"
            />

			<el-form v-if="dialogTreeItem.submitButton != ''" class="item-lhfs-0" style="margin-bottom: 0px;" ref="rowForm" :rules="rules" :model="rowForm">
                <el-form-item style="float: left;">
                    <div><span>已选中 </span><span style="font-weight: bold;">{{selectIds.length}}</span> <span>个</span></div>
                    <div v-if="selectIds.length>0"><span style="font-weight: bold;">选中：{{selectIds}}</span></div>
                </el-form-item>
                <el-form-item style="float: right;">
                    <el-select v-model="rowForm.selectAccountKey" placeholder="请选择账户" clearable style="vertical-align: bottom;">
                        <el-option v-for="(value,key) in accountManagerInfos" :key="key" :label="value.account" :value="key" ></el-option>
                    </el-select>
                    <el-button type="primary" @click.native="submit" size="mini">{{dialogTreeItem.submitButton}}</el-button>
                </el-form-item>
            </el-form>
            
        </el-dialog>
    </div>
</template>

<script>

    import DynamicTable from '@/components/DynamicTable.vue'
    import ApiGpsTag from '@/request/api-gps-tag'

    export default {
        /**
         * 组件名
         */
        name: "GpsTagAddDialog",
        /**
         * 组件引用
         */
        components: {
            // 动态表格
            DynamicTable
        },
        /**
         * 数据接收类型
         */
        props: {

            /**
             * 标题数据类型
             */
            previewTitle: {
                type: Array,
                default: function () {
                    return []
                }
            },

            /**
             * 表格数据类型
             */
            previewData: {
                type: Array,
                default: function () {
                    return []
                }
            },

            /**
             * @Des 上传地址类型
             * @Auth CC
             * @Date 2025/09/20
             */
            uploadUrl: {
                type: String,
                default: function () {
                    return ''
                }
            },

            /**
             * @Des 是否显示序号
             * @Auth CC
             * @Date 2025/09/20
             */
            showSerialNumber: {
                type: Boolean,
                default: function () {
                    return true
                }
            },

            /**
             * @Des 项目信息
             * @Auth CC
             * @Date 2025/09/20
             */
            projectInfos: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            
            /**
             * @Des 管理员账户
             * @Auth CC
             * @Date 2025/09/20
             */
            accountManagerInfos: {
                type: Object,
                default: function () {
                    return {}
                }
            },
        },
        /**
         * 数据定义
         * @returns {{}}
         */
        data() {
            return {
                /**
                 * @Des 弹出层属性
                 * @Auth CC
                 * @Date 2025/09/20
                 */
                dialogTreeItem: {
                    title: '',
                    dialogFormVisible: false,
                    submitButton: '',
                },
                // 动态表格
                dynamicTableKey: 0,
                // 上传数据集合
                uploadData: [],
                // 选择的数量
                selectNum: 0,
                // 查询表单
                searchForm:{
                    keyword: ""
                },
                // 查询结果
                searchResult: [],
                selectIds: [],
                operationLock: false,
                rowForm: {
                    selectAccountKey: '',
                },
                rules: {
                    selectAccountKey: [
                        { required: true, message: '请选择账户', trigger: 'blur' }
                    ]
                }
            }
        },
        /**
         * @Des 监听
         * @Auth CC
         * @Date 2025/09/20
         */
        watch: {
            /**
             * @Des 分页监听
             * @Auth CC
             * @Date 2025/09/20
             */
            searchForm: {
                handler(newVal, oldVal) {
                    this.search();
                },
                immediate: true,
                deep:true,
            }
        },
        /**
         * 方法定义
         */
        methods: {

            /**
            * @Description
            * @Param 筛选查询
            * @Auth CC
            * @Date 2025/09/20
            */
            search() {
                this.selectNum = 0;
                this.searchResult = [];
                if (this.searchForm.keyword == '') {
                    this.searchResult = Object.assign([], this.previewData);
                } else {
                    this.previewData.forEach((row, index) => {
                        if (row.shortId.indexOf(this.searchForm.keyword) != -1
                            || row.sid == this.searchForm.keyword
                        ) {
                            if (this.selectIds.indexOf(row.id) == -1) {
                                row.checked = false;
                            } else {
                                row.checked = true;
                            }
                            this.searchResult.push(row);
                        }
                    })
                }
                this.dynamicTableKey++;
            },

            /**
            * @Description
            * @Param 打开弹窗
            * @Auth CC
            * @Date 2025/09/20
            */
            openDialog(title, button) {
                this.dialogTreeItem.title = title;
                this.dialogTreeItem.dialogFormVisible = true;
                this.dialogTreeItem.submitButton = button;
                this.searchResult = [];
                this.selectIds = [];
                this.$nextTick(() => {
                    this.searchResult = Object.assign([], this.previewData);
                    this.$refs.dynamicTable.cleanSelect();
                })
            },

            /**
            * @Description
            * @Param 关闭弹窗
            * @Auth CC
            * @Date 2025/09/20
            */
            handleDialogClose() {
                this.$refs.dynamicTable.cleanSelect();
                this.dialogTreeItem.dialogFormVisible = false;
                this.$emit("research");
            },

            /**
            * @Description
            * @Param 选择行处理
            * @Auth CC
            * @Date 2025/09/20
            */
            selectRow(row, selection) {
                // console.log(row, selection)
                this.selectNum = selection.length;
                this.resetSelectId(selection);
            },

            /**
            * @Description
            * @Param 选择多行处理
            * @Auth CC
            * @Date 2025/09/20
            */
            selectRows(rows) {
                // console.log(rows);
                this.selectNum = rows.length;
                this.resetSelectId(rows);
            },

            /**
            * @Description
            * @Param 重置选中的id
            * @Auth CC
            * @Date 2025/09/20
            */
            resetSelectId(rows) {
                // console.log(rows);
                // 新增id
                this.searchResult.forEach((r,i) => {
                    let exist = false;
                    rows.forEach((r2, i2) => {
                        if (r2.did == r.did) {
                            exist = true;
                            if (this.selectIds.indexOf(r.did) == -1) {
                                this.selectIds.push(r.did);
                                r.checked = true;
                            }
                        }
                    });
                    if (!exist) {
                        if (this.selectIds.indexOf(r.did) != -1) {
                            this.selectIds.splice(this.selectIds.indexOf(r.did),1);
                            r.checked = false;
                        }
                    }
                })
            },

            /**
            * @Description
            * @Param 数据提交
            * @Auth CC
            * @Date 2025/09/20
            */
            submit() {
                if (this.selectIds.length == 0) {
                    this.$message({
                        message: '请选择数据',
                        type: 'info',
                        showClose: true,
                        dangerouslyUseHTMLString: true
                    });
                    return false;
                }
                if (this.uploadUrl == '') {
                    this.$message({
                        message: '访问路径找不到！',
                        type: 'warning',
                        showClose: true,
                        dangerouslyUseHTMLString: true
                    });
                    return false;
                }
                this.$refs.rowForm.validate(valid => {
                    if (!valid) return false;

                    this.operationLock = true;
                    this.$request.postJsonRequest(this.uploadUrl, {
                        dids: this.selectIds,
                        key: this.rowForm.selectAccountKey,
                    }).then(result => {
                        if (result.code == 0) {
                            this.$message({
                                message: '分配成功',
                                type: 'success',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                            this.handleDialogClose();
                            this.$emit("research");
                        } else {
                            this.$message({
                                message: result.msg,
                                type: 'error',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                        }
                        this.operationLock = false;
                    }).catch(error => {
                        console.log("分配GPS标签异常：" + this.$request.error.msg);
                        this.operationLock = false;
                    });
                });
            },
            /**
             * @Des 数据删除
             * @Auth CC
             * @Date 2025/09/20
             */
            completelyDelete() {
                if (this.selectIds.length == 0) {
                    this.$message({
                        message: '请选择数据',
                        type: 'info',
                        showClose: true,
                        dangerouslyUseHTMLString: true
                    });
                    return false;
                }
                this.$confirm(
                    '确认批量删除选中的设备吗？','询问',
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        closeOnClickModal : false,
                        type: 'warning'
                    }
                ).then(_ => {
                    this.operationLock = true;
                    this.$request.postJsonRequest(ApiGpsTag.completelyDeleteApi, {
                        dids: this.selectIds
                    }).then(result => {
                        if (result.code == 0) {
                            this.$message({
                                message: '批量删除成功',
                                type: 'success',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                            this.handleDialogClose();
                            this.$emit("research");
                        } else {
                            this.$message({
                                message: result.msg,
                                type: 'error',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                        }
                        this.operationLock = false;
                    }).catch(error => {
                        console.log("批量删除GPS标签异常：" + this.$request.error.msg);
                        this.operationLock = false;
                    });
                });
            },

        }
    }
</script>

/* CSS */
<style lang="scss" scoped>
    /deep/ .el-dialog {
        width: 90%;
    }
    /deep/ .form-dialog .el-select {
        width: auto;
    }
    /deep/ .form-dialog .el-form,
    /deep/ .form-dialog .el-form-item {
        margin-bottom: 0px;
    }
</style>



// WEBPACK FOOTER //
// src/components_outdoor/Device/GpsTagAddDialog.vue